import api from './api';

export interface AssistantReply {
  session_id: string;
  title: string;
  reply: string;
  stop: string;
  actions: { halted?: string }[];
  tokens: number;
  confidential_touched: boolean;
}

export interface SessionSummary {
  id: string;
  title: string;
  updated_at: string | null;
  messages: number;
}

class AssistantService {
  async sendMessage(message: string, sessionId?: string | null): Promise<AssistantReply> {
    return (await api.post('/assistant/message', { message, session_id: sessionId || null })).data;
  }
  async listSessions(): Promise<{ sessions: SessionSummary[] }> {
    return (await api.get('/assistant/sessions')).data;
  }
  async getSession(id: string): Promise<{ id: string; title: string; messages: { role: string; content: string }[] }> {
    return (await api.get(`/assistant/sessions/${id}`)).data;
  }
  async deleteSession(id: string): Promise<void> {
    await api.delete(`/assistant/sessions/${id}`);
  }
}

export const assistantService = new AssistantService();
export default assistantService;
